/* ============================================================
   HERB & HEAL - PRODUCT GALLERY PRELOAD

   The bug: .hh-main-image holds one <img>. The six .hh-thumb
   elements each carry an inline onclick that swaps that img's src
   to a FULL-SIZE url which has never been fetched. Measured: the
   main image was loaded (naturalWidth 1024) but every thumb image
   was loading="lazy" with naturalWidth 0. So on "next" the browser
   had nothing cached, kept painting the previous image while it
   fetched, and only swapped 1-2s later. That is the flash.

   The fix: pull every url the gallery can possibly swap to out of
   the thumbs (both their onclick handlers and their own img src),
   and warm the browser cache on load. After this the swap is a
   cache hit and paints on the next frame.

   This does not touch the gallery's own click handling, so there
   is nothing to keep in sync.
   ============================================================ */
(function () {
  'use strict';

  function collectUrls() {
    var urls = [];
    var seen = {};

    function add(u) {
      if (!u || seen[u]) return;
      seen[u] = 1;
      urls.push(u);
    }

    var thumbs = document.querySelectorAll('.hh-thumb, .hh-thumb-grid [data-index]');

    for (var i = 0; i < thumbs.length; i++) {
      var t = thumbs[i];

      // Urls hiding inside the inline onclick handler.
      var oc = t.getAttribute('onclick') || '';
      var found = oc.match(/https?:\/\/[^'"\)\s\\]+/g);
      if (found) {
        for (var j = 0; j < found.length; j++) add(found[j]);
      }

      // Common data attributes, in case the markup changes.
      add(t.getAttribute('data-full'));
      add(t.getAttribute('data-src'));
      add(t.getAttribute('data-image'));
      add(t.getAttribute('data-large'));

      // The thumb's own image is usually the same asset at a
      // smaller width, so warming it helps too.
      var img = t.querySelector('img');
      if (img) {
        add(img.getAttribute('src'));
        add(img.getAttribute('data-src'));
        // Stop them being lazy - there are only six and they are
        // above the fold on desktop.
        img.loading = 'eager';
      }
    }

    return urls;
  }

  function warm() {
    var urls = collectUrls();
    for (var i = 0; i < urls.length; i++) {
      var im = new Image();
      im.decoding = 'async';
      im.src = urls[i];
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', warm, { once: true });
  } else {
    warm();
  }
})();
